<template>
  <Transition name="slide-fade">
    <button
      v-if="showButton"
      class="fixed bottom-6 left-6 z-50 rounded-xl bg-white px-6 py-3 text-black transition-all hover:scale-105"
      style="box-shadow: 0 0 30px rgba(0, 0, 0, 0.25);"
      @click="openNewsletter">
      <span class="font-semibold">GET 10% OFF</span>
    </button>
  </Transition>
</template>

<script setup lang="ts">
const route = useRoute()
const showButton = ref(true)

// Hide button on bookings pages
const shouldShowButton = computed(() => {
  return !route.path.includes('/bookings')
})

// Watch route changes
watch(() => route.path, () => {
  showButton.value = shouldShowButton.value
}, { immediate: true })

// Open Klaviyo newsletter form
const openNewsletter = () => {
  if (window._klOnsite) {
    // Hide the button when opening form
    showButton.value = false
    
    // Open the Klaviyo form with the form ID
    window._klOnsite.push(['openForm', 'U9iiiv'])
    
    // Use MutationObserver to detect when Klaviyo form is removed/hidden
    let observer: MutationObserver | null = null
    let intervalId: ReturnType<typeof setInterval> | null = null
    
    const showButtonAgain = () => {
      showButton.value = shouldShowButton.value
      if (observer) {
        observer.disconnect()
        observer = null
      }
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
    
    // Method 1: MutationObserver to watch for DOM changes
    observer = new MutationObserver(() => {
      const klaviyoElements = document.querySelectorAll([
        '[class*="klaviyo-form"]',
        '[id*="klaviyo-form"]',
        'div[class*="klaviyo"][class*="modal"]'
      ].join(','))
      
      let hasVisibleForm = false
      klaviyoElements.forEach((el) => {
        if (el instanceof HTMLElement) {
          const styles = window.getComputedStyle(el)
          if (styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0') {
            hasVisibleForm = true
          }
        }
      })
      
      if (!hasVisibleForm && klaviyoElements.length === 0) {
        showButtonAgain()
      }
    })
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    })
    
    // Method 2: Polling fallback (in case observer doesn't catch it)
    intervalId = setInterval(() => {
      const klaviyoElements = document.querySelectorAll([
        '[class*="klaviyo-form"]',
        '[id*="klaviyo-form"]',
        'div[class*="klaviyo"][class*="modal"]'
      ].join(','))
      
      if (klaviyoElements.length === 0) {
        showButtonAgain()
      }
    }, 500)
    
    // Stop checking after 30 seconds to prevent memory leak
    setTimeout(() => {
      showButtonAgain()
    }, 30000)
  } else {
    console.warn('Klaviyo onsite not loaded')
  }
}
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>

